/*
 * @Author: JettyHuang
 * @LastEditors: JoanC-RB 15757871065@163.com
 * @Description: 学习培训
 * @Date: 2020-12-29 09:36:23
 * @LastEditTime: 2024-03-12 14:12:09
 * @FilePath: /yft-b2c-web-h5/src/pages/Learn/RouterConfig.js
 */
import { createBundle } from 'widget/Common';
import { routeAuthCodeMap } from 'utils/constants';

import FindingView from 'bundle-loader?lazy&name=FindingView!pages/Learn/Finding/FindingView';
import PlanView from 'bundle-loader?lazy&name=PlanView!pages/Learn/Plan/PlanView';
import CollegeView from 'bundle-loader?lazy&name=CollegeView!pages/Learn/College/CollegeView';
import PromotionTreeView from 'bundle-loader?lazy&name=PromotionTreeView!pages/Learn/PromotionTree/PromotionTreeView';
import MedalHallView from 'bundle-loader?lazy&name=MedalHallView!pages/Learn/PromotionTree/Medal/MedalHallView';
import DailyView from 'bundle-loader?lazy&name=DailyView!pages/Learn/Daily/DailyView';
import ThematicView from 'bundle-loader?lazy&name=ThematicView!pages/Learn/Thematic/ThematicView';
import ThematicHjView from 'bundle-loader?lazy&name=ThematicView!pages/Learn/Thematic/ThematicHjView';
import CourseView from 'bundle-loader?lazy&name=CourseView!pages/Learn/Course/CourseView';
import PdfDetailView from 'bundle-loader?lazy&name=PdfDetailView!pages/Learn/Course/PdfDetail/PdfDetailView';
import LatestCourses from 'bundle-loader?lazy&name=LatestCoursesView!pages/Learn/LatestCourses/LatestCoursesView';
import CommitView from 'bundle-loader?lazy&name=CommitView!pages/Learn/Course/Commit/CommitView';
import AddNoteView from 'bundle-loader?lazy&name=AddNoteView!pages/Learn/Course/AddNote/AddNoteView';
import HotAndLastCListView from 'bundle-loader?lazy&name=HotAndLastCListView!pages/Learn/Course/HotAndLastCList/HotAndLastCListView';
import RankView from 'bundle-loader?lazy&name=RankView!pages/Learn/My/Rank/RankView';
import PartnerView from 'bundle-loader?lazy&name=PartnerView!pages/Learn/My/Partner/PartnerView';
import StudyMapView from 'bundle-loader?lazy&name=StudyMapView!pages/Learn/My/StudyMap/StudyMapView';
import StudyMapListView from 'bundle-loader?lazy&name=StudyMapListView!pages/Learn/My/StudyMapList/StudyMapListView';
import RuleView from 'bundle-loader?lazy&name=RuleView!pages/Learn/My/Rule/RuleView';
import ScoreView from 'bundle-loader?lazy&name=ScoreView!pages/Learn/My/Score/ScoreView';
import MyPlanView from 'bundle-loader?lazy&name=MyPlanView!pages/Learn/My/Plan/PlanView';
import MyCollectView from 'bundle-loader?lazy&name=MyCollectView!pages/Learn/My/MyCollect/MyCollectView';
import AbilityView from 'bundle-loader?lazy&name=AbilityView!pages/Learn/My/Ability/AbilityView';
import MyNoteView from 'bundle-loader?lazy&name=MyNoteView!pages/Learn/My/MyNote/MyNoteView';
import ExamListView from 'bundle-loader?lazy&name=ExamListView!pages/Learn/Exam/ExamList/ExamListView';
import ExamResultView from 'bundle-loader?lazy&name=ExamResultView!pages/Learn/Exam/ExamResult/ExamResultView';
import DoExamView from 'bundle-loader?lazy&name=DoExamView!pages/Learn/Exam/ExamView';
import MyProgressView from 'bundle-loader?lazy&name=MyProgressView!pages/Learn/My/Progress/ProgressView';
import PlanDetailView from 'bundle-loader?lazy&name=PlanDetailView!pages/Learn/My/PlanDetail/PlanDetailView';
import ThematicDetailView from 'bundle-loader?lazy&name=ThematicDetailView!pages/Learn/Thematic/Detail/ThematicDetailView';
import ThematicClassView from 'bundle-loader?lazy&name=ThematicClassView!pages/Learn/Thematic/Class/ThematicClassView';
import DailyDetailView from 'bundle-loader?lazy&name=DailyDetailView!pages/Learn/Daily/DailyDetail/DailyDetailView';
import ThematicTransitView from 'bundle-loader?lazy&name=ThematicTransitView!pages/Learn/Thematic/ThematicTransit/ThematicTransitView';
import SearchView from 'bundle-loader?lazy&name=SearchView!pages/Learn/Search/SearchView';
import ToolsSearchView from 'bundle-loader?lazy&name=ToolsSearchView!pages/Learn/ToolsSearch/SearchView';
import My from 'bundle-loader?lazy&name=MyView!pages/Learn/My/MyView';
import VideoGallery from 'bundle-loader?lazy&name=VideoGallery!pages/Learn/Tools/VideoGallery/VideoGalleryView';
import ToolsView from 'bundle-loader?lazy&name=ToolsView!pages/Learn/Tools/ToolsView';
import PlusView from 'bundle-loader?lazy&name=PlusView!pages/Learn/PLUS/PlusView';
import PlusRuleView from 'bundle-loader?lazy&name=PlusRuleView!pages/Learn/PlusRule/RuleView';
import CouponOfListView from 'bundle-loader?lazy&name=CouponOfListView!pages/Learn/CouponOfList/CouponOfListView';
import VideoPunchView from 'bundle-loader?lazy&name=VideoPunchView!pages/Learn/VideoPunch/VideoPunchView';
import DownloadVideoTipView from 'bundle-loader?lazy&name=DownloadVideoTipView!pages/Learn/Download/DownloadVideoTipView';
// import DownloadVideoTipView from 'bundle-loader?lazy&name=DownloadVideoTipView!pages/Learn/Download/DownloadVideoTipView';
import InformationView from 'bundle-loader?lazy&name=FindingView!pages/Learn/Information/InformationView';
import ArticleListView from 'bundle-loader?lazy&name=FindingView!pages/Learn/ArticleList/ArticleListView';

// ------- end -------

const RouterConfig = [
  {
    path: '/learn/finding',
    title: '学习首页',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(FindingView);
    }
  },
  {
    path: '/learn/college',
    title: '48课讲堂',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(CollegeView);
    }
  },
  {
    path: '/learn/plan',
    title: '学习计划',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(PlanView);
    }
  },
  {
    path: '/learn/daily',
    title: '每日商道',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(DailyView);
    }
  },
  {
    path: '/learn/daily/detail',
    title: '每日商道-详情',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(DailyDetailView);
    }
  },
  {
    path: '/learn/thematic',
    title: '专题列表',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ThematicView);
    }
  },
  {
    path: '/learn/thematichj',
    title: '合辑展示',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ThematicHjView);
    }
  },
  {
    path: '/learn/thematic/class',
    title: '专题分类',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ThematicClassView);
    }
  },
  {
    path: '/learn/thematic/transit',
    title: '专题分类',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ThematicTransitView);
    }
  },

  {
    path: '/learn/thematic/detail/:id',
    title: '专题详情',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ThematicDetailView);
    }
  },
  {
    path: '/learn/course/detail',
    title: '课程详情',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(CourseView);
    }
  },
  {
    path: '/learn/course/pdfDetail',
    title: 'PDF',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(PdfDetailView);
    }
  },
  {
    path: '/learn/latestCourses',
    title: '最新课程',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(LatestCourses);
    }
  },
  {
    path: '/learn/course/commit',
    title: '留言',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(CommitView);
    }
  },
  {
    path: '/learn/course/addNote',
    title: '笔记',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(AddNoteView);
    }
  },
  {
    path: '/learn/course/hotAndLastCList',
    title: '',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(HotAndLastCListView);
    }
  },
  {
    path: '/learn/do/exam',
    title: '考试',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(DoExamView);
    }
  },
  {
    path: '/learn/exam/result',
    title: '考试结果',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ExamResultView);
    }
  },
  {
    path: '/learn/toolsSearch',
    title: '搜索',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ToolsSearchView);
    }
  },
  {
    path: '/learn/search',
    title: '搜索',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(SearchView);
    }
  },
  {
    path: '/learn/my/rank',
    title: '排行榜',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(RankView);
    }
  },
  {
    path: '/learn/my/partner',
    title: '我的伙伴',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(PartnerView);
    }
  },
  {
    path: '/learn/my/studyMap',
    title: '学习地图',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(StudyMapView);
    }
  },
  {
    path: '/learn/my/studyMapList',
    title: '成长学习地图',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(StudyMapListView);
    }
  },
  {
    path: '/learn/my/rule',
    title: '学分规则',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(RuleView);
    }
  },
  {
    path: '/learn/my/score',
    title: '我的学分',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ScoreView);
    }
  },
  {
    path: '/learn/my/plan',
    title: '落地计划',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(MyPlanView);
    }
  },
  {
    path: '/learn/my/collect',
    title: '我的收藏',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(MyCollectView);
    }
  },
  {
    path: '/learn/my/ability',
    title: '能力升值',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(AbilityView);
    }
  },
  {
    path: '/learn/my/note',
    title: '我的笔记',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(MyNoteView);
    }
  },
  {
    path: '/learn/plan/detail',
    title: '落地计划详情',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(PlanDetailView);
    }
  },
  {
    path: '/learn/my/exam',
    title: '考试列表',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ExamListView);
    }
  },
  {
    path: '/learn/my/progress',
    title: '学习进度',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(MyProgressView);
    }
  },
  {
    path: '/learn/my',
    title: '我的',
    authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(My);
    }
  },
  {
    path: '/learn/tools/videoGallery',
    title: '我的',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(VideoGallery);
    }
  },
  {
    path: '/learn/tools/ToolsView',
    title: '',
    // authCode: routeAuthCodeMap.EXPAND_TRAIN,
    component: () => {
      return createBundle(ToolsView);
    }
  },
  {
    path: '/learn/plus/plusview',
    title: 'plus会员',
    component: () => {
      return createBundle(PlusView);
    }
  },
  {
    path: '/learn/plus/ruleView',
    title: 'plus会员规则',
    component: () => {
      return createBundle(PlusRuleView);
    }
  },
  {
    path: '/learn/coupon/couponOfListView',
    title: '课程列表',
    component: () => {
      return createBundle(CouponOfListView);
    }
  },
  {
    path: '/learn/PromotionTree/PromotionTreeView',
    title: '晋升树',
    component: () => {
      return createBundle(PromotionTreeView);
    }
  },
  {
    path: '/learn/PromotionTree/Medal/MedalHallView',
    title: '勋章展馆',
    component: () => {
      return createBundle(MedalHallView);
    }
  },
  {
    path: '/learn/videoPunch/index',
    title: '视频打卡',
    component: () => {
      return createBundle(VideoPunchView);
    }
  },
  // {
  //   path: '/learn/video/downloadTip',
  //   title: '视频下载提示页',
  //   component: () => {
  //     return createBundle(DownloadVideoTipView);
  //   }
  // },
  {
    path: '/learn/information',
    title: '资讯',
    component: () => {
      return createBundle(InformationView);
    }
  },
  {
    path: '/learn/articleList',
    title: '资讯',
    component: () => {
      return createBundle(ArticleListView);
    }
  },
  {
    path: '/learn/video/downloadTip',
    title: '视频下载提示页',
    component: () => {
      return createBundle(DownloadVideoTipView);
    }
  }
  // ------- end -------
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Learn/RouterConfig.js